module.exports = __webpack_public_path__ + "static/media/qualitat_region_3.db4e7c9e.png";